/** What the cost figure is and what it is not. Lives beside the panel like the signal help sheet. */
export default function CostHelp({ onClose, style, rate, samples, totalSamples, measured }) {
  const perSecond = rate?.usd_per_second;
  return (
    <div className="ne-help" style={style}>
      <div className="ne-help-head">
        <span>How this is calculated</span>
        <button className="ne-help-close" onClick={onClose} title="Close">×</button>
      </div>

      <h4>What this number is</h4>
      <p>
        The <b>marginal compute cost</b> of running this one analysis: the time
        the simulation took, priced at a published on-demand rate for a
        reference machine.
      </p>
      <p>
        It is <b>machine</b> time, not waiting time, and it covers the whole
        run: the traffic assignment you wait for <i>and</i> the conflict
        microsimulation that carries on in the background after the map is
        drawn. The breakdown lists both.
      </p>
      {rate && (
        <p className="ne-help-formula">
          {rate.instance} · ${rate.usd_per_hour}/hr
          {perSecond ? ` ≈ $${perSecond.toFixed(8)}/sec` : ''}
        </p>
      )}

      <h4>What it does not include</h4>
      <p>
        Idle time, storage, data transfer and fixed infrastructure. A machine
        that stays on costs money whether or not you run anything. This figure
        answers <i>“what does one more analysis cost?”</i>, not <i>“what is the
        monthly bill?”</i>
      </p>

      <h4>Why a reference machine</h4>
      <p>
        The rate is pegged to a named instance type rather than the machine you
        happen to be talking to, so figures stay comparable across deployments —
        and a move to a cluster changes the rate, not the work a run does.
      </p>
      <p>
        Today the app and the simulation share one host, so the measured time
        carries some noise and runs slightly slower than a dedicated machine
        would. The figure is conservative rather than flattering.
      </p>

      <h4>Where the estimate comes from</h4>
      <p>
        {samples > 0 ? (
          <>The median of <b>{samples}</b> measured {samples === 1 ? 'run' : 'runs'} of
            this same kind of edit{totalSamples > samples
              ? <> ({totalSamples} across all edit types)</> : null}.</>
        ) : measured > 0 ? (
          <>A seeded figure. <b>{measured}</b> {measured === 1 ? 'run' : 'runs'} of this
            kind {measured === 1 ? 'has' : 'have'} been measured but not yet folded into
            the published estimate.</>
        ) : (
          <>A seeded figure — this combination of edits has not been measured yet.
            Treat it as an order of magnitude.</>
        )}
        {' '}The estimate is replaced by the measured value once a run finishes.
      </p>
    </div>
  );
}
